import { Document, DocumentStatuses } from 'Interfaces/Document';
import { GridItem } from 'Interfaces/Grid';
import { formatDateToHumanString } from 'Utils/formatters';

export const documentFileKeyExtractorForDocument = (document: Document) => {
  const fileKey =
    document.status === DocumentStatuses.COMPLETED
      ? document.resultPdfFileKey
      : document.pdfFileKey;

  return fileKey
    ? [
        {
          fileKey,
          fileName: `${document.title} (${formatDateToHumanString(
            document.createdAt,
          )}).pdf`,
          itemName: document.title,
        },
      ]
    : document.parts.length > 0
    ? document.parts
        .filter(part => part.filesUploaded)
        .map(part => ({
          fileKey: part.pdfFileKey,
          fileName: `${part.originalFileName.replace(
            /\.[^/.]+$/,
            '',
          )} (${formatDateToHumanString(document.createdAt)}).pdf`,
          itemName: document.title,
        }))
    : [];
};

export const documentFileKeyExtractorForSeparatedDocument = (document: Document) => {
  const fileKey =
    document.status === DocumentStatuses.COMPLETED
      ? document.resultDocumentPdfFileKey
      : document.pdfFileKey;

  return fileKey
    ? [
        {
          fileKey,
          fileName: `${document.title} (${formatDateToHumanString(
            document.createdAt,
          )}).pdf`,
          itemName: document.title,
        },
      ]
    : document.parts.length > 0
    ? document.parts
        .filter(part => part.filesUploaded)
        .map(part => ({
          fileKey: part.pdfFileKey,
          fileName: `${part.originalFileName.replace(
            /\.[^/.]+$/,
            '',
          )} (${formatDateToHumanString(document.createdAt)}).pdf`,
          itemName: document.title,
        }))
    : [];
};

export const documentFileKeyExtractorForGrid = (grid?: GridItem) => {
  if (!grid?.documents) {
    throw new Error('Selected items must be documents');
  }

  const document = grid.documents;

  const fileKey =
    document.status === DocumentStatuses.COMPLETED
      ? document.resultPdfFileKey
      : document.pdfFileKey;

  return fileKey
    ? [
        {
          fileKey,
          fileName: `${document.title} (${formatDateToHumanString(
            document.createdAt,
          )}).pdf`,
          itemName: document.title,
          chunkIndex: grid.chunkIndex,
        },
      ]
    : document.parts.length > 0
    ? document.parts
        .filter(part => part.filesUploaded)
        .map(part => ({
          fileKey: part.pdfFileKey,
          fileName: `${part.originalFileName.replace(
            /\.[^/.]+$/,
            '',
          )} (${formatDateToHumanString(document.createdAt)}).pdf`,
          itemName: document.title,
          chunkIndex: grid.chunkIndex,
        }))
    : [];
};
